import React, { useEffect, useState } from 'react'
import { useShowContext, SimpleShowLayout, Show, useTranslate, Loading, Error } from 'react-admin'
import { Grid, Container } from '@mui/material'
import { CardCommon } from '../../../uiElements'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { getDay } from '../../sales/reservation/helper/getDay'
import { bannerTypeServices } from 'src/services/reservation/bannerType/BannerType.service'
import { productTypeServices } from 'src/services/reservation/product-type/product_type.service'
import { FormDivider } from 'src/components/uiElements/fields/Divider'
import { PreviewLanding } from './logic/PreviewLanding'

const ShowWrapper = ({ children }) => <Container maxWidth='false'> {children}</Container>

const ShowContent = () => {
  const translate = useTranslate()
  const {
    error, // error returned by dataProvider when it failed to fetch the record. Useful if you want to adapt the view instead of just showing a notification using the `onError` side effect.
    isLoading, // boolean that is true until the record is available for the first time
    record, // record fetched via dataProvider.getOne() based on the id from the location
  } = useShowContext()

  useEffect(() => {
    ;(async () => {
      await Promise.all([

      ])
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isLoading) {
    return <Loading />
  }

  if (error) {
    return <Error />
  }

  return (
    <SimpleShowLayout>
      <CardCommon
        title={translate('ra.entity.banner-type')}
        actions={<CardCrudBottomButtons btnEdit={true} />}
      >
        <Grid container spacing={3}>
          <ShowListElement label={'ID'} value={record.id} />
          <ShowListElement label={translate('ra.field.short_name')} value={record.short_name} />
          <ShowListElement label={translate('ra.field.title')} value={record.title} />
          <ShowListElement label={translate('ra.field.description')} value={record.description} />
          <ShowListElement label={translate('ra.field.datetime_from')} value={record?.datetime_from ? getDay(record?.datetime_from, true) : null} />
          <ShowListElement label={translate('ra.field.datetime_to')} value={record?.datetime_to ? getDay(record?.datetime_to, true) : null} />
          <ShowListElement label={translate('ra.field.menu_visible')} value={record.menu_visible} type='boolean' />
          <ShowListElement label={translate('ra.field.newsletter_visible')} value={record.newsletter_visible} type='boolean' />
          <ShowListElement label={translate('ra.field.form_visible')} value={record.form_visible} type='boolean' />
          <ShowListElement label={translate('ra.field.default_form')} value={record.default_form} />
          <ShowListElement label={translate('ra.field.meta')} value={record.meta} />

          <FormDivider show={true} text={translate('ra.title.sectors')} />
          {record?.sectors?.length > 0 && (
            record.sectors.map((sector, i) => (
              <Grid container key={sector.id}>
                <ShowListElement label={translate('ra.field.sector_type')} value={sector.banners.length > 0 ? 'Banners' : 'HTML'} />
                <ShowListElement label={translate('ra.field.is_active')} value={sector.is_active} type='boolean' sm={8} />
                <ShowListElement label={translate('ra.field.title')} value={sector.title} />
                <ShowListElement label={translate('ra.field.button_text')} value={sector.text_link} />
                <ShowListElement label={translate('ra.field.link')} value={sector.link} />

                {sector.banners.length > 0 && (
                  <Grid item xs={12} style={{ paddingLeft: 90 }}>
                    <FormDivider show={true} text={translate('ra.field.banners')} className='dashed' />
                    {sector.banners.map(banner => (
                      <Grid container key={banner.id}>
                        <ShowListElement label={translate('ra.field.is_active')} value={banner.is_active} type='boolean' />
                        <ShowListElement label={translate('ra.field.banner_type')} value={banner.banner_relation.banner_type_relation.long_name} />
                        <ShowListElement label={translate('ra.field.title')} value={banner.banner_relation.title} />
                      </Grid>
                    ))}
                  </Grid>
                )}

                {i !== record.sectors.length - 1 && (
                  <FormDivider show={false} />
                )}
              </Grid>
            ))
          )}

          <Grid item xs={12} style={{ marginTop: 20 }}>
            <PreviewLanding landing={record} />
          </Grid>
        </Grid>
      </CardCommon>
    </SimpleShowLayout>
  )
}

export const LandingShow = (props) => {
  return (
    <Show component={ShowWrapper} {...props} className='CrudShowContainer' actions={null}>
      <ShowContent {...props} />
    </Show>
  )
}